export enum LoadTrackingTypeIds {
    TruckerTools = 1,
    Manual = 2,
    Project44 = 3,
    MacroPoint = 4
}

export interface LoadTrackingEvent {
    LoadTrackingId: number;
    LoadTrackingLocationId: number;
    IsOnTime: boolean;
    UpdatedOn: string;
    LoggedBy: string;
    LoggedByUserId: number;
    City: string;
    State: string;
    LocationIANACode: string;
    CheckCallName: string;
    CheckCallType: number;
    Description: string;
    Notes: string;
    // FacilityName: string;
    // FacilityAddress: string;
    // FacilityCity: string;
    // FacilityState: string;
    // FacilityZipCode: string;
    // FacilityCountry: string;
    LoadTrackingVendorId: LoadTrackingTypeIds;
    VendorName: string;
    LoadTrackingLocationType: number;
    EventDate: string;
    CreatedOn: string;
}